module.exports = __webpack_public_path__ + "static/media/cq_mail b.2aa9a91d.svg";